export default {
  REGISTER_TOOL: '@WS_EDITOR/CUSTOM_TOOLS/REGISTER_TOOL',
  SET_ACTIVE_TOOL: '@WS_EDITOR/CUSTOM_TOOLS/SET_ACTIVE_TOOL',
};
